import { BaseResource } from '/@/modules/core/app/resources/BaseResource';
import { Route } from '/@/modules/core/app/constants/api.constants';
import { SpotlightGroup } from '@/modules/spotlight/models/SpotlightGroup';
import { SpotlightSearchParams } from '@/modules/spotlight/models/SpotlightSearchParams';

export class SpotlightResource extends BaseResource {
  async search(params: SpotlightSearchParams): Promise<SpotlightGroup[]> {
    return this.getData(Route.SPOTLIGHT, SpotlightGroup, params);
  }
}

export default new SpotlightResource();
